import { render } from "./Importador.vue?vue&type=template&id=35c19415"
import script from "./Importador.vue?vue&type=script&lang=js"
export * from "./Importador.vue?vue&type=script&lang=js"

import "./Importador.vue?vue&type=style&index=0&id=35c19415&lang=css"

import exportComponent from "/home/circleci/repo/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__